import { ApiMethodForm } from "components/Forms/ConnectionCreatorEditorFormSections/ApiMethodForm";
import { StepForm } from "components/Forms/ConnectionCreatorEditorFormSections/StepForm";
import { Collapseable } from "components/UI/Collapseable/Collapseable";
import { FC } from "react";


import FormStructureData = App.Data.FormStructureData;
import FormFieldData = App.Data.FormFieldData;

interface ApiMethodPanelProps {
    formStructure: FormStructureData;
    name: number;
    handleRemoveMethod: () => void;
    disabled: boolean;
}

export const ApiMethodPanel: FC<ApiMethodPanelProps> = ({ formStructure, name, handleRemoveMethod, disabled }) => {
    const leadFields = formStructure?.formFields ?? [];

    return (
        <Collapseable
            header={<StepForm name={name} handleRemoveMethod={handleRemoveMethod} disabled={disabled} />}
            collapsible={disabled ? "disabled" : "icon"}
            className={disabled ? "bg-neutral-100 opacity-45 p-1" : "bg-neutral-100 p-1"}
        >
            <ApiMethodForm leadFields={leadFields as Array<FormFieldData>} name={name} />
        </Collapseable>
    );
};
